"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _fileSaver = require("file-saver");
var _xlsx = _interopRequireDefault(require("xlsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _default(header, dataSource, fileName) {
  return new Promise(function (resolve, reject) {
    let headersKeys = [],
      headersValues = [],
      worksheetColumns = [];
    header && header.length > 0 && header.forEach(e => {
      headersKeys.push(e && e.dataIndex ? e.dataIndex : e.key);
      headersValues.push(e && e.title);
    });
    var worksheet = _xlsx.default.utils.json_to_sheet(dataSource, {
      header: headersKeys
    });
    var workbook = _xlsx.default.utils.book_new();
    function convertNumberToLetter(n) {
      var ordA = "a".charCodeAt(0);
      var ordZ = "z".charCodeAt(0);
      var len = ordZ - ordA + 1;
      var s = "";
      while (n >= 0) {
        s = (String.fromCharCode(n % len + ordA) + s).toUpperCase();
        n = Math.floor(n / len) - 1;
      }
      return s;
    }
    headersValues && headersValues.forEach((data, index) => {
      delete worksheet[convertNumberToLetter(index).concat("1")].w;
      worksheet[convertNumberToLetter(index).concat("1")].v = data;
    });
    const range = _xlsx.default.utils.decode_range(worksheet["!ref"]);
    range.s.c = 0;
    range.e.c = headersValues && headersValues.length - 1;
    worksheet["!ref"] = _xlsx.default.utils.encode_range(range);
    headersValues && headersValues.length > 0 && headersValues.map(e => {
      let wch = {
        wch: 30
      };
      worksheetColumns.push(wch);
    });
    worksheet["!cols"] = worksheetColumns;
    _xlsx.default.utils.book_append_sheet(workbook, worksheet, fileName);
    var workbookOut = _xlsx.default.write(workbook, {
      bookType: "xlsx",
      type: "binary"
    });
    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    (0, _fileSaver.saveAs)(new Blob([s2ab(workbookOut)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }), "".concat(fileName, ".xlsx"));
    if (true) {
      resolve("Stuff worked!");
    } else {
      reject(Error("It broke"));
    }
  });
}